<template>
  <v-col cols="12">
    <v-breadcrumbs
      :items="items"
      class="text-caption text-capitalize pa-0 pt-2"
    >
      <template v-slot:prepend>
        <v-icon icon="mdi-home" size="small" color="grey-darken-2"></v-icon>
      </template>
      <template v-slot:divider>
        <v-icon icon="mdi-chevron-right" color="grey-darken-2"></v-icon>
      </template> </v-breadcrumbs
  ></v-col>
</template>
<script setup>
const route = useRoute();
const items = ref([]);

function findPath() {
  const segments = route.path.split("/").filter((segment) => segment !== "");
  const breadcrumbs = [];
  segments.reduce((prev, curr) => {
    const title = (curr.charAt(0).toUpperCase() + curr.slice(1)).replace(
      /-/g,
      " ",
    );
    const disabled = false;
    const href = prev + "/" + curr;
    breadcrumbs.push({ title, disabled, href });
    return href;
  }, "");
  if (segments.includes("terjadwal") || segments.includes("terintegrasi")) {
    items.value = breadcrumbs.map((breadcrumb, index, array) => {
      if (index === array.length - 1) {
        return { ...breadcrumb, disabled: true };
      }
      if (index === 1 && array.length > 2) {
        const queryString = route.query.batchId
          ? `?batchId=${route.query.batchId}`
          : "";
        return {
          ...breadcrumb,
          href: breadcrumb.href + queryString,
        };
      }
      return breadcrumb;
    });
    return;
  }
  items.value = breadcrumbs;
  const lastIdx = items.value.length - 1;
  const pathArr = route.path.split("/");
  if (items.value.length > 0) {
    items.value[lastIdx].disabled = true;
  }
  if (items.value.length > 1)
    items.value[1].title = `${!pathArr.includes("pembelajaran-ekosistem") ? "Materi" : ""} ${items.value[1].title}`;
}

onMounted(() => {
  findPath();
});

watch(
  () => route.fullPath,
  () => {
    findPath();
  },
);
</script>
